import { baseApi } from '@/lib/api/baseApi';
import { ImpactListResType, profilePayload } from '@/types/landingPageTypes';

import type { Builder } from '../commonApiType/apiBuilderTypes';

export const userProfileApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    getUserProfileDetails: builder.query({
      query: userId => ({
        url: `/appmanagement/optimize/v3/user-profile/${userId}`,
      }),
      transformResponse: response => response,
    }),
    updateProfile: builder.mutation<
      ImpactListResType,
      { formPayload: FormData; userId: string }
    >({
      query: ({ formPayload, userId }) => ({
        url: `/appmanagement/optimize/v3/user-profile/user-id/${userId}`,
        method: 'PUT',
        body: formPayload,
      }),
      transformResponse: (response: ImpactListResType) => response,
      invalidatesTags: [{ type: 'existingEmail', id: 'LIST' }],
    }),
    updateLicenseForm: builder.mutation<
      ImpactListResType,
      { payload: profilePayload }
    >({
      query: ({ payload }) => ({
        url: '/appmanagement/optimize/v3/user-profile/upgrade-license-form',
        method: 'PUT',
        body: payload,
      }),
      transformResponse: (response: ImpactListResType) => response,
    }),
    verifyOtp: builder.mutation<
      unknown,
      { payload: { otp: string; sessionInfo: string }; key: string }
    >({
      query: ({ payload, key }) => ({
        url: `/appmanagement/optimize/v1/user/verify-number?key=${key}`,
        method: 'POST',
        body: payload,
      }),
      transformResponse: response => response,
    }),
  }),
  overrideExisting: false,
});
